import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'

interface RevealProps {
    children: ReactNode
    className?: string
    delay?: number
    y?: number
    duration?: number
    trigger?: 'view' | 'mount'
    amount?: number
}

export const EASE_EXPO: [number, number, number, number] = [0.16, 1, 0.3, 1]

export const Reveal: FC<RevealProps> = ({
    children,
    className,
    delay = 0,
    y = 28,
    duration = 1,
    trigger = 'view',
    amount = 0.2
}): ReactNode => {
    const target = { opacity: 1, y: 0 }

    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            transition={{ duration, delay, ease: EASE_EXPO }}
            {...(trigger === 'mount'
                ? { animate: target }
                : { whileInView: target, viewport: { once: true, amount } })}
        >
            {children}
        </motion.div>
    )
}
